// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  academyCategories: 'fb670d0a0bce7a40e6d3e1866599b496',
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyLessons: 'def9dd292a20a515a8e833080e617979',
  academyModules: 'db5a8b4e3d5d31db4f7706783b6e3d40',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '3688d6e7dc0acbb3fa916977d4639d93',
  agents: 'a265dd72d416c2e07efd47b7b136ad2c',
  agentSessions: 'c165fdd44849a7b2ce06a51207841434',
  allProjects: '3f512179c9ce5267b2c2fee534c58b69',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  articles: '21e2a589930880b02849c0d5cd1784c6',
  banners: '32c82d12d5c598fd6b14b7964b5838a8',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidRatings: '79165c6e4378ec4106df9d0e76daeb3e',
  bids: '5d2bfbca90a794554d9e1514cb8c7e34',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  billingAgreements: '6aff8760dae9a8c9b439ce3ba1f2919c',
  canViewEmployerProfile: 'e4cd062351bbdf3e5ac60870fc756d88',
  cartItems: 'd7e644ef2b74da6880c36c9077117702',
  carts: '04dab66fc081c92d5a5e263d3514911d',
  certifications: '43fd8862311f73a91a22f2e897799065',
  contacts: 'a6ebe80433512c6ef46a788883fb95fe',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestComments: '098c32fedec41d5a70c226b75074cfd8',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '9fc5f8a3bc62bac260b86749b1c8c1eb',
  contestEntryMessages: '4a9fbfd103bddca15b23bfa2c4e9eb6e',
  contestFees: '12a03576c5a766a03818e2a660483e90',
  contestFiles: 'abe08370d1fcbb188064e2fc20abf5f7',
  contestHandovers: '9ac9b70b0f42d6f0f2f079df0e8437ce',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contestInterestedFreelancers: 'c43f3df6657d87978a841360838e64d2',
  contestMessages: '3d0dcac1ea1c6124c123778e5a9f8493',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestQuickviewEntries: 'c4b52c5a220e47c235d1f7a58c344f6d',
  contests: '5673a8794d75b6f0dec4565666e10b5d',
  contestViewContests: '3af2a3d9ee94b87d70b7deb1f9613d8b',
  contestViewEntries: '0b61963d71a44dea9b8d7ed8f979f41b',
  contestViewEntryIds: 'c675b0fd2ab3104e632665b8acbf7c48',
  contestViewNewOrUpdatedEntries: '62b044801e8c0866983e8371ee004aef',
  countries: '31f2bba0d5f522a2cdc070e42c294e8a',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  dashboardPolls: '4a5ec8404c9cc72f492206255a087633',
  dashboardWidgets: '47db5a7df92772b22a46b9a35aff6594',
  deloitteSubscriberEmails: '1c0091df229fdc72087ecdc965f702a0',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: '85dc2b2a2031be813a9643266a4dd010',
  depositPageVars: '10745ad12dfa11c2d7857d8c38cd00ee',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  discoverCollectionItems: 'd49ecd957990be88a5c0146f9b819efc',
  discoverCollections: 'b6c5537b17ad7c0c7810babc4b9fd056',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '724a2a8039a094de4f884ff49b4df8e3',
  educations: '8e7f7e3d902633deb708d813bb61e9dc',
  emailIsAvailableForArrow: 'a0ddf5b621669626a62f47df472f3a87',
  employerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  encodedUrl: 'a86dacdcfe22e36258a0ec0a180fcd6f',
  exchangeRates: 'f83b34c90a913ca6e474c7386150b771',
  experiences: '40986fee31964385e45bc33aef538cf7',
  freelancerReputations: '3cebc056801046cf1be2c88ddc8d791d',
  freelancerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  grants: '9c686ead3a8a42039d19192f81b7516d',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  invoices: 'd0fc4cd9c09cc18075303cd8968637c3',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  issuingInstitution: '95b335961666b09b4cf2b3207794d307',
  jobClassifier: 'be13e9b8247389acf7d14f58d02098f6',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  membershipBenefits: '35e0ee8c6f67d33168c1cdb83aa7e531',
  membershipDowngrades: '5e55af3581868b7b8e293b90768eadb8',
  membershipSubscriptions: '0c4efaf0be704e7d0f20a57f3a6fade5',
  messageAttachments: '651faffef24bfb290da9076ef4094f1e',
  messages: '36654931839897621790bd305acaf33c',
  milestoneDrafts: 'ed83b1532fab3e99ea4948b61895670d',
  milestoneRequests: '4a03ed6f70c6e69c43377c1555c84e45',
  milestones: 'dd4c206df0c2df32b10e9eb36b6cd9f5',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  nativeExchangeRates: 'f83b34c90a913ca6e474c7386150b771',
  nearbyProjects: '38cd7a0997c782632c26a6078ec8a735',
  newsfeed: '5bddf4db81a5c55255e0541625bf234d',
  nextPreviousUsers: '7b59c6479775e199046719f3797eb497',
  notifications: 'b5fff72c7515075008e42589a038023e',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  onBehalfProjects: '4e0e81938a24131a4a2d84d7591bdbd6',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  portfolios: '3c40ea345b4f366f0803500eb4c46bf8',
  postJobPageFormState: '2920557eb0379f12d033dfedb3d7f7c0',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  profileCategories: '6e2e5dd8262e1e3a576a232c5d674ada',
  profileViewUsers: '17600cd01ffb37594ba37d2eb7e67a83',
  projectBidInfo: 'b4d2126be7882b6ccbad9606986efe03',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  projectFeed: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeedFailingContests: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeedFailingProjects: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectInvite: 'e0d5e878b75f9ffb0d4a185d388b6030',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projects: '61eecd662fb1dc086ea26520af3b4d13',
  projectStats: '85b6917a5634c621f4387c949aff07b9',
  projectUpgradeFees: '0186a0b393731d70225b3172e4e83014',
  projectViewBids: '39238ece7073383d1ca5d0adc84dceae',
  projectViewProjects: '0bbf64c1b051b78e9288c56e069281c9',
  projectViewUsers: 'ba5d898018f0bb526c5b2b384615bfb0',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  recommendedUsernames: 'c1730888439c6e53b0b7c05b9e7edef2',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  reviews: 'bf070f7af04c0047f56f08b7a7b92e46',
  searchHistory: '7a826dfd6e549968829c4e407125bb5d',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchMyProjectsBuyer: 'c1c4c45e381ac26d2254b5cb5afa7f23',
  searchUsers: '72a360cc2d3224464474083019427bac',
  showcase: '18adf43194b5889bd466ed83c48af3fc',
  showcaseSource: '528a53ba8ced968954a3585a5225a22c',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  skills: 'b0b9d47616e234db600127beb4ebf884',
  suggestedSkills: '74db00b149426fa76661ddd86621e02d',
  superuserBids: '5d2bfbca90a794554d9e1514cb8c7e34',
  superuserMessages: '36654931839897621790bd305acaf33c',
  superuserMilestones: 'dd4c206df0c2df32b10e9eb36b6cd9f5',
  superuserProjectViewProjects: '0bbf64c1b051b78e9288c56e069281c9',
  superuserThreads: '31d0eca5cadc85df4899a966e7ac33bf',
  tagFamilyMembers: 'bec8b904ff3c95ce66f8f068ad560215',
  tagProperties: 'c921ffb9aa46d085b4828622489c8d71',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  tasks: '01c5cb8d0996464fe2f088daf4d4e359',
  tax: '09e8975a9499f263c33cb9db2747c307',
  teamMembers: 'bb6a0e0816be6616cd7e94e9d7cb3386',
  teams: '2683231453ddb11b5b8781fbae14592a',
  testing: '26c562fe7058803b53d1db7116494963',
  threadProjects: '8e5beac892021bcf19709fad4d3dcbf7',
  threads: 'ba8ab8a01e6b6d24f13be543b8344ea7',
  threadUsers: 'b856d2426c8302198a7490ba0be49fd4',
  timeTrackingPunches: 'a86fa2830faaceb3958281ddcd8da60e',
  timeTrackingSession: 'afd7dcc3791c3071706c3f11df175ed9',
  timeTrackingSessionAggregate: 'c21f646077e99cb71252ac21e55dab7e',
  toastNotifications: '402fcfaf4ce4848247a5b8273a05e99f',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  tracks: 'e432997983ba0bedffd22d84f0d1e939',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  twoFactorDetails: 'bf5a516c4382437117e334903aaeae3c',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  userBalances: 'ac222b4645e3d514e8b493905d12f8f1',
  userBidLimit: 'bbd8ee874d96afa7257b9e5dd2604c55',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userDepositMethods: 'f49d9cf97d9c96227a57a4a3a6d997bf',
  userGiveGetDetails: 'd111cdcfd30887f43734ba920b81f71e',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: 'da0c59a47b3523b86e8c8e0e35f72d54',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userIsArrowWhitelisted: 'd57f78c922d51723060e1b7efc222273',
  userOnPaytmMembershipPlan: '41cbb1f644ef5ec65b4c7216aac23311',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  users: 'b856d2426c8302198a7490ba0be49fd4',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  usersFollow: 'bbea0e01511c4dca66ded193ee07fca0',
  usersLocation: '9797e769ac66c9ef482e89cb7ce0794f',
  usersProfile: 'c62fa3dab13ee0385184d8fd9f07af4c',
  usersRecommend: '0a80e5d13a75c26e4e765d9042d3acb6',
  usersSelf: '6f433dbd6ef0bf3f49231eff3b7a67f0',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationRequest: 'bc73642503328592cdad638f892acdbc',
  violationReports: 'dbfad1ca25a7e3cc8ee195731a134564',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
};
